import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { EmployeeGroup } from "~/providers/employee-group-provider";

interface EmployeeGroupState {
  selectedEmployeeGroup?: EmployeeGroup;
  setSelectedEmployeeGroup: (selectedEmployeeGroup?: EmployeeGroup) => void;
  employeeGroupDialogOpen: boolean;
  setEmployeeGroupDialogOpen: (open: boolean) => void;
}

export const useEmployeeGroupStore = create<EmployeeGroupState>()(
  devtools((set) => ({
    selectedEmployeeGroup: undefined,
    setSelectedEmployeeGroup(selectedEmployeeGroup) {
      set(() => ({ selectedEmployeeGroup }));
    },
    employeeGroupDialogOpen: false,
    setEmployeeGroupDialogOpen(open) {
      set(() => ({ employeeGroupDialogOpen: open }));
    },
  })),
);
